import { Button, Stack, Text, useMediaQuery, VStack } from "@chakra-ui/react";
import { StaticImage } from "gatsby-plugin-image";
import React from "react";

const BlogCTABanner = () => {
  const [isBase] = useMediaQuery("(max-width: 479px)");
  const [isMd] = useMediaQuery("(min-width: 480px) and (max-width: 768px)");
  const [isLg] = useMediaQuery("(min-width: 769px)");

  let size;
  if (isBase) {
    size = "429px";
  } else if (isMd) {
    size = "322px";
  } else if (isLg) {
    size = "311px";
  }
  return (
    <Stack pt={10} w="100%" alignItems="center" gap={0} position="relative">
      <StaticImage
        placeholder="none"
        loading="lazy"
        alt="Form background image"
        src="../../../images/form_bg.webp"
        layout="fullWidth"
        style={{
          height: size,
          width: "100%",
          objectFit: "cover",
          objectPosition: "center",
          backgroundColor: "transparent !important",
          position: "absolute",
        }}
        quality={100}
      />
      <VStack gap={0} zIndex={1} py={10} px={{ base: 5, md: 0 }}>
        <Text
          textAlign="center"
          pb={5}
          className="light-text"
          fontSize={{ base: "40px", md: "48px" }}
          lineHeight="100%"
          color="#fff"
          w={{
            base: "248px",
            sm: "408px",
            md: "800px",
            lg: "600px",
            xl: "800px",
          }}
        >
          Ready to transform your financial management?
        </Text>
        <Text
          color="rgba(255, 255, 255, 0.92)"
          className="regular-text"
          fontSize="18px"
          textAlign="center"
        >
          Sign up with Vellis today and unlock the full potential of your
          finances.
        </Text>
        <Button
          mt={10}
          bg="#fff"
          borderRadius="full"
          w="116px"
          className="medium-text"
          fontWeight="600"
          fontSize="18px"
          color="#116266"
          h="48px"
        >
          Sign Up
        </Button>
      </VStack>
    </Stack>
  );
};

export default BlogCTABanner;
